import React from 'react';

import './button.styles.scss';

const Button = ({onClick,children}) => (
  <button className="buttonBaglantiEkle" onClick={onClick} >{children}</button>
);

export default Button;